import axios from 'axios';

 const API_BASE_URL = 'https://api.rkvisionindia.com/api';


const axiosInstance = axios.create({
    baseURL: API_BASE_URL, 

    headers: {
        'Content-Type': 'application/json',
    }
});

// 1. ATTACH TOKEN TO REQUESTS
axiosInstance.interceptors.request.use(
    (config) => {
        const accessToken = localStorage.getItem('capstonne_access_token');
        if (accessToken && accessToken !== "undefined") {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 2. CATCH 401 AND TRIGGER LOGOUT
axiosInstance.interceptors.response.use(
    (response) => response, 
    (error) => {
        // If the server says "Unauthorized"
        if (error.response?.status === 401 || error.response?.status === 403) {
            
            // 1. Nuclear Wipe (Remove everything from the browser's memory)
            localStorage.clear();
            sessionStorage.clear();

            // 2. Broadcast the Event (This triggers your SessionModal.js)
            const event = new CustomEvent("capstonne_session_expired");
            window.dispatchEvent(event);

            // 3. Stop the request here
            return new Promise(() => {}); // Returns a "pending" promise to stop UI errors
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;